(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.initCarousel(signal);

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.closePopovers();
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.stopAutoplay();
        const slide = event.target.closest('[data-slide]');
        if (slide) this.goTo(Number(slide.dataset.slide));
        this.initQuickShop();
        if (event.target.classList.contains('kit-shoppable-hero__hotspot')) {
          const btn = event.target.querySelector('button');
          if (btn) window.setTimeout(() => btn.click(), 50);
        }
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.abortController?.abort();
    }

    /* ---------- Carrusel ---------- */

    initCarousel(signal) {
      this.carousel = this.querySelector('[data-look-carousel]');
      if (!this.carousel) return;

      this.slides = Array.from(this.carousel.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.carousel.querySelectorAll('[data-look-dot]'));
      this.current = 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      const prev = this.carousel.querySelector('[data-look-prev]');
      const next = this.carousel.querySelector('[data-look-next]');
      if (prev) prev.addEventListener('click', () => { this.goTo(this.current - 1); this.restartAutoplay(); }, { signal });
      if (next) next.addEventListener('click', () => { this.goTo(this.current + 1); this.restartAutoplay(); }, { signal });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.lookDot));
          this.restartAutoplay();
        }, { signal });
      });

      let startX = 0;
      this.carousel.addEventListener('touchstart', (e) => {
        startX = e.changedTouches[0].clientX;
      }, { passive: true, signal });
      this.carousel.addEventListener('touchend', (e) => {
        const dist = e.changedTouches[0].clientX - startX;
        if (Math.abs(dist) > 45) {
          this.goTo(this.current + (dist < 0 ? 1 : -1));
          this.restartAutoplay();
        }
      }, { passive: true, signal });

      this.carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.goTo(this.current - 1); this.restartAutoplay(); }
        if (e.key === 'ArrowRight') { this.goTo(this.current + 1); this.restartAutoplay(); }
      }, { signal });

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.carousel.dataset.autoplay === 'true' && !reduced && !Shopify.designMode;
      this.interval = Math.max(3000, Number(this.carousel.dataset.interval) || 6000);

      this.carousel.addEventListener('mouseenter', () => this.stopAutoplay(), { signal });
      this.carousel.addEventListener('mouseleave', () => this.startAutoplay(), { signal });
      this.carousel.addEventListener('focusin', () => this.stopAutoplay(), { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay(); else this.startAutoplay();
      }, { signal });

      this.startAutoplay();
    }

    goTo(index) {
      if (!this.slides || !this.slides.length) return;
      const total = this.slides.length;
      const target = ((index % total) + total) % total;
      if (target === this.current && this.slides[target].classList.contains('is-active')) return;

      this.closePopovers();
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === target));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', i === target ? 'true' : 'false'));
      this.current = target;
    }

    startAutoplay() {
      if (!this.autoplay || this.timer) return;
      if (this.querySelector('kit-popover:popover-open')) return;
      this.timer = window.setInterval(() => this.goTo(this.current + 1), this.interval);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    closePopovers() {
      this.querySelectorAll('kit-popover:popover-open').forEach((p) => p.hidePopover());
    }

    /* ---------- Vista rápida (sin cambios) ---------- */

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
